import { render, staticRenderFns } from "./PairedProductList.vue?vue&type=template&id=52a51508&"
import script from "./PairedProductList.vue?vue&type=script&lang=js&"
export * from "./PairedProductList.vue?vue&type=script&lang=js&"
import style0 from "./PairedProductList.vue?vue&type=style&index=0&id=52a51508&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports